import { apiService } from '@/services/api.service';

type ShortUrlResponse = {
  success: boolean;
  short_url?: string;
  error?: string;
};

export const generateShortUrl = async (
  fullUrl: string
): Promise<ShortUrlResponse> => {
  try {
    const axiosResponse = await apiService.post(
      '/short-urls',
      { url: fullUrl },
    );

    const response = axiosResponse as unknown as ShortUrlResponse;

    return {
      success: response.success,
      short_url: response.short_url,
    };
  } catch (err: any) {
    return {
      success: false,
      error: err.response?.data?.error || 'Failed to generate short URL',
    };
  }
};

export const fetchOriginalUrl = async (uniqueId: string): Promise<string | null> => {
    try {
      const response: any = await apiService.get(`/short-urls/${uniqueId}`);

      if (response?.url) {
        return response.url;
      }
  
      console.error('Short URL not found or invalid:', response);
      return null;
    } catch (error: any) {
      console.error('Error fetching short URL:', error.response?.data || error.message);
      return null;
    }
};
